export default "__VITE_ASSET__7d561164__"